module.exports = __webpack_public_path__ + "img/3.a1a9fff9.jpg";